import * as types from './mutation-types'

export const fetchUserGuides = ({ commit, dispatch, state }, params) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`/api/user-guides`, { params }).then((response) => {
            commit(types.SET_USER_GUIDES, response.data.userGuides.data)
            commit(types.SET_TOTAL_USER_GUDIES, response.data.userGuides.total)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
export const fetchUserGuide = ({ commit, dispatch }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`/api/user-guides/${id}`).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
export const searchUserGuide = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`/api/user-guides?${data}`).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}


export const addUserGuide = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('/api/user-guides', data).then((response) => {
            if (response.data.success == true){
                commit(types.ADD_USER_GUIDE, response.data.userGuide)
            }
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const statusChange = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`/api/user-guides/${data}/statusChange`).then((response) => {
            if(response.data.success){
                commit(types.UPDATE_USER_GUIDE, response.data.userGuide)
            }
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
export const updateUserGuide = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.put(`/api/user-guides/${data.id}`, data).then((response) => {
            commit(types.UPDATE_USER_GUIDE, response.data.userGuide)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const deleteUserGuide = ({ commit, dispatch, state }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.delete(`/api/user-guides/${id}`).then((response) => {
            if (response.data.success) {
                commit(types.DELETE_USER_GUIDE, id)
            }
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
export const deleteMultipleUserGuides = ({ commit, dispatch, state }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`/api/user-guides/delete`, { 'ids': state.selectedUserGuides }).then((response) => {
            commit(types.DELETE_MULTIPLE_USER_GUIDES, state.selectedUserGuides)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const setSelectAllState = ({ commit, dispatch, state }, data) => {
    commit(types.SET_SELECT_ALL_STATE, data)
}

export const selectAllUserGuides = ({ commit, dispatch, state }) => {
    if (state.selectedUserGuides.length === state.userGuides.length) {
        commit(types.SET_SELECTED_USER_GUIDES, [])
        commit(types.SET_SELECT_ALL_STATE, false)
    } else {
        let allItemIds = state.userGuides.map(item => item.id)
        commit(types.SET_SELECTED_USER_GUIDES, allItemIds)
        commit(types.SET_SELECT_ALL_STATE, true)
    }
}

export const selectUserGuide = ({ commit, dispatch, state }, data) => {
    commit(types.SET_SELECTED_USER_GUIDES, data)
    if (state.selectedUserGuides.length === state.userGuides.length) {
        commit(types.SET_SELECT_ALL_STATE, true)
    } else {
        commit(types.SET_SELECT_ALL_STATE, false)
    }
}
